import { render, staticRenderFns } from "./PreviewRegistrationPages.vue?vue&type=template&id=62846f36&scoped=true&"
import script from "./PreviewRegistrationPages.vue?vue&type=script&lang=js&"
export * from "./PreviewRegistrationPages.vue?vue&type=script&lang=js&"
import style0 from "./PreviewRegistrationPages.vue?vue&type=style&index=0&id=62846f36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62846f36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBadge,VBtn,VCol,VHover,VIcon,VRow,VTab,VTabs})
